import { Injectable  } from '@angular/core';

@Injectable ()
export class UsersService {
  user: number;

  setNewEdit(value) {
    this.user = value;
  }
  getNewEdit() {
    return this.user;
  }

  

}
